import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialTugboatMaterialPageState,
  TugboatMaterialItemData,
} from "../core/_model.tugboat";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../common/models/StoreDefaultModel";

export type ActionedTugboatMaterial = {
  data: TugboatMaterialItemData | null;
  action: ActionsKey;
};

type TugboatMaterialDataType = {
  tugboatMaterialList: any;
  detail: TugboatMaterialItemData | null;
  actioned: ActionedTugboatMaterial | null;
  totalItems?: number;
  setDetail: (detail: TugboatMaterialItemData | null) => void;
  setTugboatMaterialList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedTugboatMaterial | null) => void;
};

export const useTugboatMaterialStore = create<TugboatMaterialDataType>(
  (set) => ({
    tugboatMaterialList: [],
    detail: null,
    actioned: null,
    totalItems: 0,
    setDetail: (detail) => set((state) => ({ detail })),
    setTugboatMaterialList: (data) =>
      set((state) => ({
        tugboatMaterialList: data?.member,
        totalItems: data?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useTugboatMaterialListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialTugboatMaterialPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
